import './ScoreCard.style.less'
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons'
import { memo, useEffect, useState } from 'react'
import { Row } from 'antd'
import defaultLogo from '@/assets/images/icons/fingertips.svg'
import { floor, isNil } from 'lodash'
import { numberWithCommas } from '@/utils/common'

interface Props {
  icon: any
  score: any
  subTitle: string
  sign?: string
  backgroundColor?: string
  percentage: number
  precision?: number
  showPercentage?: boolean
}

function ScoreCard(props: Props) {
  const {
    icon,
    score,
    subTitle,
    sign = '',
    percentage = null,
    precision = 0,
    showPercentage,
  } = props
  const { backgroundColor = '#848484' } = props

  const [timer, setTimer] = useState(0)
  const diverNumber = Math.round(score / 100)

  useEffect(() => {
    if (timer == score) return
    if (timer > score) {
      setTimer(score)
    }
    const time = setTimeout(() => {
      const _diverNumber = diverNumber === 0 ? 1 : diverNumber
      setTimer(timer + _diverNumber)
      return () => {
        clearTimeout(time)
      }
    }, 5)
  }, [timer])

  return (
    <div className="scorecard-container" style={{ backgroundColor }}>
      <div>
        <p className="cart-score-subtitle">{subTitle}</p>
        <div className="score-container">
          <span className="cart-score-title">
            {numberWithCommas(isNaN(timer) ? 0 : floor(timer, precision))}
            {sign}
          </span>
          {showPercentage && (
            <Row align="bottom">
              {isNil(percentage) || percentage === 0 ? (
                <div className="percentage-container">
                  <span
                    className="percentage-title"
                    style={{ color: '#848484' }}
                  >
                    {percentage ? `${percentage}%` : 'N/A'}
                  </span>
                </div>
              ) : (
                <div className="percentage-container">
                  {percentage >= 0 ? (
                    <CaretUpOutlined
                      style={{ color: '#65BF73', marginRight: '2px' }}
                    />
                  ) : (
                    <CaretDownOutlined
                      style={{ color: '#C03261', marginRight: '2px' }}
                    />
                  )}
                  <span
                    className="percentage-title"
                    style={{
                      color: percentage >= 0 ? '#65BF73' : '#C03261',
                    }}
                  >
                    {`${percentage.toFixed(0)}%`}
                  </span>
                </div>
              )}
            </Row>
          )}
        </div>
      </div>
      {icon ? (
        <div className="icon-container">
          <img src={icon} width="24px" height="24px" />
        </div>
      ) : (
        <div className="icon-container">
          <img src={defaultLogo} width="24px" height="24px" />
        </div>
      )}
    </div>
  )
}

export default memo(ScoreCard)
